import Vue from "vue";
import VueRouter from "vue-router";
import Layouts from "../components/layout/index.vue";
import { name } from "file-loader";

Vue.use(VueRouter);

const routes = [{
    path: "",
    redirect: "home",
    component: Layouts,
    children: [{
            path: "/login",
            meta: {
                title: "登录",
                icon: "el-icon-s-home",
                oneself: true,
                hide: true,
                gorouter: false,
                admin: false
            },
            component: () =>
                import ("../views/login/index.vue"),
        },
        {
            path: "/home",
            meta: { title: "首页", icon: "el-icon-s-home", gorouter: true, admin: false },
            // component: () => import("../views/home/index.vue"),
            component: Layouts,
            children: [{
                    path: "inParts",
                    meta: { title: "进件", icon: "el-icon-plus", gorouter: true, role: [1, 2, 3, 4, 9, 11] },
                    component: () =>
                        import ("../views/inParts/index.vue"),
                },
                {
                    path: "preCheckCredit",
                    meta: { title: "预查征信", icon: "el-icon-view", gorouter: true, role: [1, 2, 3, 4, 9, 11] },
                    component: () =>
                        import ("../views/preCheckCredit/index.vue"),
                },
                {
                    path: "inspectCart",
                    meta: { title: "预查车况", icon: "el-icon-view", gorouter: true, role: [1, 2, 3, 4, 9, 11] },
                    component: () =>
                        import ("../views/inspectCart/index.vue"),
                },
                {
                    path: "homeVisits",
                    meta: { title: "家访", icon: "el-icon-s-home", gorouter: true, role: [1, 2, 3, 4, 9, 11] },
                    component: () =>
                        import ("../views/homeVisits/index.vue"),
                },
                {
                    path: "dataReview",
                    meta: { title: "资料审核", icon: "el-icon-s-check", gorouter: true, role: [3, 4, 5, 9, 10, 11] },
                    component: () =>
                        import ("../views/dataReview/index.vue"),
                },
                {
                    path: "requestFund",
                    meta: { title: "请款资料", icon: "el-icon-document", gorouter: true, role: [1, 2, 3, 4, 6, 7, 8, 9, 11] },
                    component: () =>
                        import ("../views/requestFund/index.vue"),
                },
                {
                    path: "post-loan",
                    meta: { title: "贷后资料", icon: "el-icon-s-claim", gorouter: true, role: [1, 2, 3, 4, 9, 11] },
                    component: () =>
                        import ("../views/post-loan/index.vue"),
                },
            ],
        },
        // 管理员页面
        {
            path: "/user",
            meta: { title: "用户管理", icon: "el-icon-user-solid", gorouter: true, admin: true, qyAdmin: true },
            // component: () => import("../views/home/index.vue"),
            component: Layouts,
            children: [{
                path: "index",
                meta: { title: "用户管理", icon: "el-icon-user", gorouter: true, role: [9, 11] },
                component: () =>
                    import ("../../src/views/userManage/user/index.vue"),
            }, ]
        },
        {
            path: "/other",
            meta: { title: "其他管理", icon: "el-icon-s-tools", gorouter: true, admin: true },
            // component: () => import("../views/home/index.vue"),
            component: Layouts,
            children: [{
                    path: "bank",
                    meta: { title: "银行管理", icon: "el-icon-bank-card", gorouter: true, role: [1, 2, 3, 4, 9] },
                    component: () =>
                        import ("../views/otherManage/bank/index.vue"),
                },
                {
                    path: "car",
                    meta: { title: "车商管理", icon: "el-icon-truck", gorouter: true, role: [1, 2, 3, 4, 9] },
                    component: () =>
                        import ("../views/otherManage/car/index.vue"),
                },
                {
                    path: "mortgageArea",
                    meta: { title: "区域管理", icon: "el-icon-location-information", gorouter: true, role: [1, 2, 3, 4, 9] },
                    component: () =>
                        import ("../views/otherManage/mortgageArea/index.vue"),
                },
                {
                    path: "guaranteeFirm",
                    meta: { title: "担保公司管理", icon: "el-icon-s-claim", gorouter: true, role: [1, 2, 3, 4, 9] },
                    component: () =>
                        import ("../views/otherManage/guaranteeFirm/index.vue"),
                },
            ]
        },
        {
            path: "/personalCenter",
            meta: { title: "密码修改", icon: "el-icon-s-tools", gorouter: true, admin: true },
            // component: () => import("../views/home/index.vue"),
            component: () =>
                import ("../views/personalCenter/index.vue"),
        },
        // 管理员页面-风控额度管理
        {
            path: "/system",
            meta: { title: "系统管理", icon: "el-icon-s-tools", gorouter: true, admin: true },
            // component: () => import("../views/home/index.vue"),
            component: Layouts,
            children: [{
                    path: "riskLimit",
                    meta: { title: "风控额度管理", icon: "el-icon-s-tools", gorouter: true, role: [9] },
                    component: () =>
                        import ("../views/riskLimit/index.vue"),
                }, {
                    path: "fadada",
                    meta: { title: "法大大参数配置", icon: "el-icon-s-tools", gorouter: true, role: [9] },
                    component: () =>
                        import ("../views/fadada/index.vue"),
                },
                // {
                //     path: "Embed",
                //     meta: { title: "外部链接", icon: "el-icon-s-tools", gorouter: true, role: [9] },
                //     component: () =>
                //         import ("../views/Embed/index.vue"),
                // }
            ]
        },
        // 分公司管理
        {
            path: "/affiliates",
            meta: { title: "分公司管理", icon: "el-icon-office-building", gorouter: true, admin: true },
            // component: () => import("../views/home/index.vue"),
            component: Layouts,
            children: [{
                path: "index",
                meta: { title: "分公司管理", icon: "el-icon-office-building", gorouter: true, role: [9] },
                component: () =>
                    import ("../views/affiliates/index.vue"),
            }, ]
        },
        // 企业控制台
        {
            path: "/enterprise",
            meta: { title: "法大大", icon: "el-icon-office-building", gorouter: true, admin: false },
            // component: () => import("../views/home/index.vue"),
            component: Layouts,
            children: [{
                path: "contract",
                meta: { title: "控制台", icon: "el-icon-cpu", gorouter: true, role: [5, 9] },
                component: () =>
                    import ("../views/Embed/index.vue"),
            }, {
                path: "bill",
                meta: { title: "账单", icon: "el-icon-tickets", gorouter: true, role: [9] },
                component: () =>
                    import ("../views/linkPage/orderLink.vue"),
            }, {
                path: "templateManagement",
                meta: { title: "模版管理", icon: "el-icon-document", gorouter: true, role: [9] },
                component: () =>
                    import ("../views/linkPage/templateManagement.vue"),
            }, {
                path: "archive",
                meta: { title: "归档合同", icon: "el-icon-document", gorouter: true, role: [9] },
                component: () =>
                    import ("../views/archive/index.vue"),
            }, ]
        },
        // {
        //   path: "system",
        //   meta: { title: "系统管理", icon: "el-icon-s-home", gorouter: true },
        //   component: Layouts,
        //   children: [
        //     {
        //       path: "item1",
        //       name: 'item1',
        //       meta: { title: "用户管理", icon: "el-icon-s-home", gorouter: true },
        //       component: () => import("../views/system/item1.vue"),
        //     },
        //     {
        //       path: "item2",
        //       meta: { title: "产品管理", icon: "el-icon-s-home", gorouter: true },
        //       component: () => import("../views/system/item2.vue"),
        //     },
        //   ],
        // },
    ],
}, ];



const router = new VueRouter({
    mode: "hash",
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    // router.addRoute(

    // );
    // router.removeRoute("item1");
    let token = JSON.parse(localStorage.getItem("userinfo"));
    if (token) {
        // this.router[0].children.push()
    }
    if (to.meta.gorouter) {
        //判断该路由是否需要权限
        if (token) {
            //判断store是否有登录信息，存储在token字段
            next();
        } else {
            next({
                path: "/login",
                query: { redirect: to.fullPath }, //将该路由path传入login页面，登陆成功后跳转到该页面
            });
        }
    } else {
        next();
    }
});
// router.beforeEach((to, from, next) => {
//   // 设置当前页签名称
//   document.title = to.meta.title;
//   next();
// });

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js